import { useContext, useState } from "react";
import { t } from "i18next";

import { styled } from "@mui/material/styles";
import { WaiverRoles } from "../../../../../../types/enums";

import { RootContext } from "../../../../../../context/RootContext";
import CustomModal from "../../../../../../components/common/CustomModal";
import ReRequestWaiverConfirmation from "./ReRequestWaiverConfirmation";
import WaiverList from "./WaiversList";
import { deletePricingException } from "../../../../../../utils/pricingException";
// import PreviewIcon from "../../../../../../assets/PreviewIcon.svg";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function RequestWaiver(props: any) {
  const {
    setIsRequestPricingWaiver,
    requestedWaivers,
    isLoading,
    setIsLoading,
    fetchWaivers,
  } = props;
  const { userPermissions } = useContext(RootContext) ?? {};
  const isRequestor = !userPermissions?.includes(WaiverRoles.PRICING_WAIVER_APPROVER);
  const [showConfirmationPopup, setshowConfirmationPopup] = useState(false);
  const [resetWaiverData, setResetWaiverData] = useState(false);

  const handleRequestWaiverClick = () => {
    const isWaiverAlreadyRequested = requestedWaivers.some((waiver: any) => waiver?.data?.waiverStatus === "Requested");
    if (!isWaiverAlreadyRequested) {
      setIsRequestPricingWaiver(true);
    } else {
      setshowConfirmationPopup(true);
    }
  };

  const onConfirmationPopupClose = () => {
    setshowConfirmationPopup(false);
  };

  // A pending exception already exists — confirming here deletes it
  // outright (the waiver service does support a delete: DELETE
  // /waiverservice/waiver/:waiverId), then opens the request form fresh.
  // Submitting that form calls createPricingException (see
  // RequestWaiverWrapper.handleWaiverRequest — with the pending waiver
  // gone, requestedWaivers is empty, so it takes the "create" branch, not
  // "re-request"), making a brand new record rather than appending a
  // response onto the deleted one.
  const confirmReRequestWaiver = async () => {
    const pendingWaiverId = requestedWaivers?.[0]?._id;
    setIsLoading?.(true);
    try {
      if (pendingWaiverId) {
        await deletePricingException(pendingWaiverId);
        await fetchWaivers?.();
      }
      setIsRequestPricingWaiver(true);
      setResetWaiverData(true);
    } catch (err) {
      console.error("Something went wrong while deleting the pending price exception. ERROR:", err);
    } finally {
      setshowConfirmationPopup(false);
      setIsLoading?.(false);
    }
  };

  return (
    <>
      {showConfirmationPopup && ( 
        <CustomModal
          open={showConfirmationPopup}
          handleClose={onConfirmationPopupClose}
          className={"saveApplication"}
        >
          <ReRequestWaiverConfirmation
            onConfirm={confirmReRequestWaiver}
            onClose={onConfirmationPopupClose}
            isLoading={isLoading}
          />
        </CustomModal>
      )}
      <WaiverList
        {...props}
        t={t}
        isRequestor={isRequestor}
        handleRequestWaiverClick={handleRequestWaiverClick}
        resetWaiverData={resetWaiverData}
        setResetWaiverData={setResetWaiverData}
      />
      <></>
    </>
  );
}
